import { ButtonTriggerEvent } from '../../../common/components';
import { HubPlace } from '../../../models/hub/hub.place';

export class EditManuallyPlaceImagesModalActions {
  confirm: (event: ButtonTriggerEvent, place: HubPlace, coverImg: string) => void;
  cancel?: () => void;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.manually.place.images.modal/edit.manually.place.images.modal.provider.ts